import { createSnapshotPageSource } from "../../../shared/api/snapshot-page";
import { readAllPages } from "../../../shared/api/read-all-pages";
import { includesSearch } from "../../../shared/api/client-search-page";
import { baseUrl, GET_ALL_ADVERTISMENT_DATA } from "../../../shared/api/endpoints";
import { configReq } from "../../../shared/lib/functions";

export function createAdvertisementDataSource(token) {
  return createSnapshotPageSource({
    load: async (config) => {
      const result = await readAllPages(`${baseUrl}/${GET_ALL_ADVERTISMENT_DATA}?Limit=50`, { ...configReq(token), ...config });
      const data = result.data.map((row) => ({ ...row, value: row.value && typeof row.value === "object" ? JSON.stringify(row.value) : row.value }));
      const header = result.header.map((column) => ["advertisement", "field"].includes(column.name)
        && data.some((row) => row[column.name] && typeof row[column.name] === "object")
        ? { ...column, type: "objectfield", link: "title" } : column);
      return { ...result, header, data };
    },
    matches: (row, term) => includesSearch([row.id, row.advertisementId, row.fieldId, row.value,
      typeof row.advertisement === "string" ? row.advertisement : row.advertisement?.title,
      typeof row.field === "string" ? row.field : row.field?.title], term),
  });
}
